import ls from '@/util/ls';

export default {
	path: 'super',
	name: 'SuperUser',
	component: () => import('@/views/superUser/Index'),
	redirect: { name: 'Publications' },
	meta: {
		title: 'Super User',
	},
	beforeEnter: (to, from, next) => {
		const roles = ls.get('roles');
		if (roles.indexOf('super_admin') === -1) {
			next({ name: 'NotFound' });
		}
		else {
			next();
		}
	},
	children: [
		{
			path: 'publications',
			name: 'Publications',
			component: () => import('@/views/superUser/Publications'),
			meta: {
				title: 'Publications',
			},
		},
		{
			path: 'parse-article',
			name: 'ParseArticle',
			component: () => import('@/views/superUser/ParseArticle'),
			meta: {
				title: 'Parse Article',
			},
		},
		{
			path: 'accounts',
			name: 'SuperAccounts',
			component: () => import('@/views/superUser/Accounts'),
			meta: {
				title: 'Accounts',
			},
		},
	],
};
